// client/src/coms/voip/voiceUtils.js
export function buildVoiceRoomName(server, channel) {
  const serverObj = server && typeof server === 'object' ? server : null;
  const channelObj = channel && typeof channel === 'object' ? channel : null;

  const sidRaw =
    serverObj && serverObj.db_id != null
      ? String(serverObj.db_id)
      : serverObj && serverObj.server_id != null
      ? String(serverObj.server_id)
      : serverObj && serverObj.id != null
      ? String(serverObj.id)
      : '';

  const sidMatch = String(sidRaw).match(/\d+/g);
  const sid = sidMatch && sidMatch.length ? sidMatch[sidMatch.length - 1] : '';

  let cidRaw = '';
  if (channelObj && channelObj.db_id != null) cidRaw = String(channelObj.db_id);
  else if (channelObj && channelObj.channel_id != null) cidRaw = String(channelObj.channel_id);
  else if (channelObj && channelObj.id != null) cidRaw = String(channelObj.id);

  const cidMatch = String(cidRaw).match(/\d+/g);
  const cid = cidMatch && cidMatch.length ? cidMatch[cidMatch.length - 1] : '';

  return `coms_${sid}_${cid}`;
}

// LiveKit room name -> the app's room name. A deployment sharing its LiveKit server with another one
// (beta) namespaces its rooms on that server as "<namespace>~coms_<s>_<c>" (server/utils/livekitRooms.js).
export function logicalRoomName(name) {
  return String(name || '').trim().replace(/^[a-z0-9]{1,16}~/, '');
}